module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communities) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.website')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communities), function(community) {
    return _c('community-list-row', {
      key: community.uid,
      attrs: {
        "community": community
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communities.length >= 10),
      expression: "communities.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.website')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c5d21a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityListTable.vue
// module id = 473
// module chunks = 0